import { render, staticRenderFns } from "./KusBaseMenu.vue?vue&type=template&id=689ed6d9"
import script from "./KusBaseMenu.vue?vue&type=script&lang=js"
export * from "./KusBaseMenu.vue?vue&type=script&lang=js"
import style0 from "./KusBaseMenu.vue?vue&type=style&index=0&id=689ed6d9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports